import { SceneTemplate } from "@/lib/utils/lomda/types";

export const templateI: SceneTemplate = {
    name: "תבנית ט",
    aspectRatio: "1:1.414",
    branding: {
        background: "primary",
        foreground: undefined,
    },
    avatar: undefined,
    scene: {
        scale: 91.66,
        rounded: true,
        location: {
            x: 31.79,
            y: 4.17,
        },
    },
};
